import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useApp } from "@/context/AppContext";
import { DiyaLoader } from "@/components/Ornaments";
import { Button } from "@/components/ui/button";
import { Landmark, User2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, setRole } = useAuth();
  const { t } = useApp();
  const processed = useRef(false);
  const [needRole, setNeedRole] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/auth?mode=login"); return; }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (data.session_token) localStorage.setItem("db_token", data.session_token);
        setUser(data.user);
        window.history.replaceState({}, document.title, "/auth/callback");
        if (data.needs_role) {
          const pending = localStorage.getItem("db_pending_role");
          if (pending) { await setRole(pending); localStorage.removeItem("db_pending_role"); nav("/dashboard"); }
          else setNeedRole(true);
        } else { nav("/dashboard"); }
      } catch (e) { toast.error("గూగుల్ లాగిన్ విఫలమైంది"); nav("/auth?mode=login"); }
    })();
  }, []);

  const pick = async (role) => {
    setBusy(true);
    try { await setRole(role); toast.success("స్వాగతం! 🙏"); nav("/dashboard"); }
    catch (e) { toast.error("లోపం"); } finally { setBusy(false); }
  };

  if (!needRole) return <div className="parchment-texture min-h-screen"><DiyaLoader label="లాగిన్ అవుతోంది..." /></div>;

  return (
    <div className="parchment-texture min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-surface rounded-2xl temple-shadow gold-border p-8 text-center animate-fade-up">
        <div className="text-4xl">🙏</div>
        <h1 className="font-display text-2xl font-bold text-maroon mt-2">{t("select_role")}</h1>
        <div className="flex gap-3 mt-6">
          <button data-testid="callback-role-temple" disabled={busy} onClick={() => pick("temple")} className="flex-1 p-5 rounded-xl border-2 border-goldline/40 hover:border-saffron hover:bg-marigold/10">
            <Landmark className="w-7 h-7 mx-auto text-saffron mb-2" /><div className="font-telugu text-sm font-semibold text-maroon">{t("role_temple")}</div>
          </button>
          <button data-testid="callback-role-archaka" disabled={busy} onClick={() => pick("archaka")} className="flex-1 p-5 rounded-xl border-2 border-goldline/40 hover:border-saffron hover:bg-marigold/10">
            <User2 className="w-7 h-7 mx-auto text-saffron mb-2" /><div className="font-telugu text-sm font-semibold text-maroon">{t("role_archaka")}</div>
          </button>
        </div>
      </div>
    </div>
  );
}
